import Vue from 'vue'
import Router from 'vue-router'
import Management from '@/layouts/Management'
import NotFound from '@/views/common/NotFound'
import Auth from '@/helpers/authorizations'
import store from '@/stores'
import routerModules from './router_modules'

/**
 * 加载主题
 *
 * @param theme {String} theme 主题
 */
Vue.use(Router)

const router = new Router({
  // history 需要nginx配置: https://router.vuejs.org/zh/guide/essentials/history-mode.html#后端配置例子
  mode: 'history',
  routes: [
    // 欢迎页
    {
      path: '/',
      meta: {
        auth: Auth.common
      }
    },
    // 公共页面
    {
      path: '/404',
      name: '404',
      component: NotFound,
      meta: {
        auth: Auth.common
      }
    },
    // 管理后台的路由
    {
      path: '/management', // 因为项目历史原因需要使用 / 作为管理后台的路由，一般推荐使用 /admin 或者 /management
      name: 'Management',
      component: Management,
      children: [
        {
          path: '/dashboard',
          component: () => import('@/views/dashboard/Index'),
          meta: {
            auth: Auth.showConsoleTodayAnalysis
          }
        },
        {
          path: '/today_analysis',
          redirect: '/dashboard'
        },
        {
          path: '/welcome',
          redirect: '/dashboard'
        }
      ]
    },
    ...routerModules
    // 路由找不到时，返回到404
    // {
    //   path: '*',
    //   redirect: '/404'
    // }
  ]
})

router.beforeEach((to, from, next) => {
  let permittedAuthorizations = store.state.app.permittedAuthorizations
  // 如果 permittedAuthorizations 是还没有请求数据或者是公共权限的，直接给予通过，否则对 permittedAuthorizations 进行正真的权限判断
  let hasAuthorization = permittedAuthorizations === undefined || to.meta.auth === 'common'
  if (!hasAuthorization) {
    hasAuthorization = permittedAuthorizations.some(auth => {
      return auth === to.meta.auth
    })
  }

  if (hasAuthorization) {
    if (to.path == '/') {
      store
        .dispatch('app/fetchInfoAfterSignIn')
        .then(() => {
          next(store.state.app.preferredWelcomePage)
        })
        .catch(() => {
          Vue.prototype.$toast.error(management.$t('common.fail_to_get_data'))
        })
    } else {
      next()
    }
  } else {
    management.$notice.show(management.$t('common.not_authorization'), 'warning')
    console.log(`[Auth check] Missing auth: ${to.meta ? to.meta.auth : undefined}`)
  }
})

router.afterEach(() => {
  // 切换页面后滚动到顶部
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  if (document.getElementById('content')) {
    document.getElementById('content').scrollTop = 0
  }
})

router.onError(error => {
  console.error(error)

  // 处理因版本升级后，用户停留在旧版本，没有刷新页面，会导致加载 Chunk 失败。捕获异常并弹窗提示用户。
  // i.e. "ChunkLoadError: Loading chunk chunk-b8b2d156 failed."
  if (/loading( css)? chunk [\w-]+ failed\./i.test(error.message) && navigator.onLine) {
    let url = new URL(window.location.href)
    // 获取版本信息
    management.$http.get(url.origin + '/version.json?i=' + new Date().getTime() / 1000).then(resp => {
      let info = resp.data
      let uiVersion = info.gitBranchName

      management
        .$confirm(`系统已经升级到版本 ${uiVersion}，请刷新页面后重新操作`, {
          title: '刷新页面提示',
          confirmButtonText: management.$t('common.btn.refresh'),
          cancelButtonText: management.$t('common.btn.cancel'),
          type: 'warning'
        })
        .then(() => {
          window.location.reload()
        })
    })
  }
})

export default router
